// The app is loaded dynamically so that a startup configuration error (see config/env.ts) can be shown
// on screen instead of leaving a blank page.
import('./app/index').catch((error: unknown) => {
  console.error('Application failed to start:', error);
  const rootElement = document.getElementById('root');
  if (rootElement) {
    const message = document.createElement('pre');
    message.style.cssText = 'margin:2rem;white-space:pre-wrap;color:#b00020;font-family:monospace';
    message.textContent = `Application failed to start.\n\n${error instanceof Error ? error.message : String(error)}`;
    rootElement.replaceChildren(message);
  }
});
